import {
  LocalMallIcon,
  CardGiftcardIcon,
  ShoppingBasketIcon,
  StyleIcon,
} from '@occc/ui-design-system';

import { SweepstakesType } from './types';

export const sweepstakesTypes = [
  {
    type: SweepstakesType.ProductPurchase,
    title: 'Product Purchase',
    description:
      'Members can enter sweepstakes by purchasing a specific quantity of products in a single transaction.',
    icon: LocalMallIcon,
  },
  {
    type: SweepstakesType.VarietyChallenge,
    title: 'Variety Challenge',
    description:
      'Members can enter sweepstakes by purchasing a specific quantity of multiple products in a single transaction.',
    icon: ShoppingBasketIcon,
  },
  {
    type: SweepstakesType.SpendBonus,
    title: 'Spend Bonus',
    description:
      'Members can enter sweepstakes every time they spend a specific amount at your business.',
    icon: CardGiftcardIcon,
  },
  {
    type: SweepstakesType.Reward,
    title: 'Reward',
    description: 'Members can enter sweepstakes by spending their points.',
    icon: StyleIcon,
  },
];
